import {fromJS} from 'immutable';

import {
  GET_PAYMENT_CARDS_REQUEST,
  GET_PAYMENT_CARDS_SUCCESS,
  GET_PAYMENT_CARDS_FAILURE,
  GET_STRIPE_CUSTOMER_REQUEST,
  GET_STRIPE_CUSTOMER_SUCCESS,
  GET_STRIPE_CUSTOMER_FAILURE,
  ADD_PAYMENT_CARD_REQUEST,
  ADD_PAYMENT_CARD_SUCCESS,
  ADD_PAYMENT_CARD_FAILURE,
  DELETE_PAYMENT_CARD_REQUEST,
  DELETE_PAYMENT_CARD_SUCCESS,
  DELETE_PAYMENT_CARD_FAILURE,
  STRIPE_CONFIRM_PAYMENT_INTENT_REQUEST,
  STRIPE_CONFIRM_PAYMENT_INTENT_SUCCESS,

 SETUP_STRIPE_CHECKOUT_REQUEST_REQUEST,
 SETUP_STRIPE_CHECKOUT_REQUEST_SUCCESS,
SETUP_STRIPE_CHECKOUT_REQUEST_FAILURE ,
} from '../actions/paymentsActions';

// Initial state
const initialState = fromJS({loading: false, error: false, cards: [], stripeCustomer: false});

// Reducer
export default function PaymentsReducer(state = initialState, action = {}) {

  let paymentCards = state.get('cards');
  switch (action.type) {
    case SETUP_STRIPE_CHECKOUT_REQUEST_REQUEST:
      return state.set('loading', true).set('error', false);
    case GET_PAYMENT_CARDS_REQUEST:
      return state.set('loading', true).set('error', false).set('cards', false);

    case GET_PAYMENT_CARDS_SUCCESS:
      return state.set('loading', false).set('cards', action.payload);

    case GET_STRIPE_CUSTOMER_REQUEST:
      return state.set('loading', true).set('error', false).set('stripeCustomer', false);

    case GET_STRIPE_CUSTOMER_SUCCESS:
      return state.set('loading', false).set('stripeCustomer', fromJS(action.payload)).set('cards', action.payload.sources.data);
    case SETUP_STRIPE_CHECKOUT_REQUEST_SUCCESS:
      return state.set('loading', false);

    case ADD_PAYMENT_CARD_REQUEST:
      return state.set('loading', true).set('error', false).set('recentCard', false);

    case ADD_PAYMENT_CARD_SUCCESS:
      let updatedCards = [...paymentCards, action.payload];
      console.log("updatedCards", updatedCards);
      return state.set('loading', false).set('recentCard', action.payload).set('cards', updatedCards);

    case DELETE_PAYMENT_CARD_REQUEST:
      return state.set('loading', true).set('error', false);

    case DELETE_PAYMENT_CARD_SUCCESS:
      let deleteCardId = action.payload.id;
      updatedCards = Object.values(paymentCards).filter(card => deleteCardId !== card.id)
      return state.set('loading', false).set('cards', updatedCards);

    case GET_STRIPE_CUSTOMER_FAILURE:
    case ADD_PAYMENT_CARD_FAILURE:
    case GET_PAYMENT_CARDS_FAILURE:
    case DELETE_PAYMENT_CARD_FAILURE:
    case SETUP_STRIPE_CHECKOUT_REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    
    case STRIPE_CONFIRM_PAYMENT_INTENT_REQUEST:
      return state.set('loading', true).set('error', false);
    
    case STRIPE_CONFIRM_PAYMENT_INTENT_SUCCESS:
      return state.set('loading', false).set('error', false);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/paymentsReducer.js